import { Component } from '@angular/core';
import { ActionApiResponse, CityParkingDiscountByIdResponse, CityParkingDiscountPayload, ExecuteCityparkingDiscount } from '../../../../core/models/card.model';
import { InputComponent } from "../../../../tools/forms/input/input.component";
import { CommonModule } from '@angular/common';
import { Providers } from '../../../../core/models/information.model';
import { MyVehicleAllResponse } from '../../../../core/models/user.model';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { SelectComponent } from "../../../../tools/forms/select/select.component";
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { ApiHandlerService } from '../../../../tools/services/api/handler-api/apiHandler.service';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../core/services/api-form.service';
import { ModalAdminActivityHistoryComponent } from '../../modals/system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../core/models/system-settings/admin-activity-log.model';

@Component({
  selector: 'app-discount-card-details',
  imports: [
    InputComponent,
    CommonModule,
    FormsModule,
    SelectComponent,
    ModalAdminActivityHistoryComponent,
  ],
  templateUrl: './discount-card-details.component.html',
  styleUrl: './discount-card-details.component.css'
})
export class DiscountCardDetailsComponent {
  // URL 
  urlDiscountCardId: string | null = null;

  // User
  userId: number | null = null;

  // Cityparking Discount 
  cityparkingDiscountPayload: CityParkingDiscountPayload | null = null;
  cityparkingDiscountByIdResponse: CityParkingDiscountByIdResponse | null = null;
  // {
  //   id: 1,
  //   siteId: 1,
  //   siteName: 'สาขาใหญ่',
  //   name: 'ส่วนลดจอดรถรายเดือน',
  //   type: true,
  //   amount: 50,
  //   startDate: new Date('2025-09-01'),
  //   endDate: new Date('2025-09-30'),
  //   status: 1,
  //   createDate: new Date('2025-09-01'),
  //   remarks: 'ส่วนลดจอดรถรายเดือน',
  //   approveDate: new Date('2025-09-02'),
  //   qty: 1,
  //   maxUsage: 100,
  //   codePrefix: 'CP-MONTHLY-50',
  //   details: [
  //     {
  //       id: 1,
  //       name: 'ส่วนลดจอดรถรายเดือน',
  //       code: 'CP-MONTHLY-50',
  //       activate: true,
  //       status: 1,
  //       createDate: new Date('2025-09-01'),
  //       activateDate: new Date('2025-09-02'),
  //       maxUsage: 100,
  //       usageCount: 42,
  //     },
  //     {
  //       id: 2,
  //       name: 'โปรโมชั่นลูกค้าใหม่',
  //       code: 'NEW-USER-25',
  //       activate: false,
  //       status: 0,
  //       createDate: new Date('2025-08-10'),
  //       activateDate: null,
  //       maxUsage: 50,
  //       usageCount: 10,
  //     },
  //   ]
  // }

  // (Value)
  siteName: string = '';
  name: string = '';
  type: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  amount: number = 0;
  limit: number = 0;
  status: number = 1;
  codePrefix: string = '';
  qty: number = 0;
  maxUsage: number = 1;
  remark: string = '';

  // (Site)
  searchProvider: string = '';
  allProviders: Providers[] = [];
  siteId: number | null = null;
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  selectCarPlate: MyVehicleAllResponse[] = [];
  selectedCar: string | null = null;

  // (Type)
  selectType: { name: string; value: boolean } = { name: 'เงิน', value: false };
  typeOptions: { name: string; value: boolean }[] = [
    { name: 'เงิน', value: false },
    { name: 'เปอร์เซ็น', value: true },
  ];


  // Modal
  showSelectProviderModal: boolean = false;
  showConfirmModal: boolean = false;
  showModalSite: boolean = true

  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  // Security
  isDisableInput: boolean = false;
  isLoading: boolean = false;
  isValidateText: { where: string, result: boolean } = { where: '', result: false }
  isValidateNumber: { where: string, result: boolean } = { where: '', result: false }
  isValidateTextNumber: { where: string, result: boolean } = { where: '', result: false }


  constructor(
    private apiHandler: ApiHandlerService,
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private toast: ToastService,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) { }
  ngOnInit(): void {
    // Default
    this.getProviders();
    this.userId = parseInt(this.cookieService.get('user_id'));

    // Cityparking Discount Details
    // อ่าน param id จาก route
    this.route.paramMap.subscribe((params) => {
      this.urlDiscountCardId = params.get('id');
      //console.log('Current Url ID:', this.urlDiscountCardId);

      if (this.urlDiscountCardId) {
        this.isDisableInput = true;

        this.getCityparkingDiscountByIdResponse(this.urlDiscountCardId);
      }
    });



  }

  /* -------------------------------- Function -----------------------------------------*/
  /* ---- style ---- */

  /* ---- Function ---- */

  /* ---- Site ----*/
  filteredProviders(): Providers[] {
    if (!this.searchProvider) return this.allProviders;
    return this.allProviders.filter((p) =>
      p.name.toLowerCase().includes(this.searchProvider.toLowerCase())
    );
  }
  selectProvider(provider: Providers) {
    this.showSelectProviderModal = false;
    this.siteId = provider.id;
    this.siteName = provider.name;

    //console.log('Site ID', this.siteId);
    setTimeout(() => {
      //this.getFeeDetails(this.siteId ?? 0);
      this.carFilteredPlateList = [];
      this.selectCarPlate = [];
    }, 200);
  }

  /* ---- Type ----*/
  onChangeSelectType(option: { name: string; value: boolean }) {
    this.selectType = option;
    this.type = option.value;
  }

  /* ---- Generate Code ----*/
  onClickGenerateCode() {
    const body: ExecuteCityparkingDiscount = {
      uid: this.userId ?? 0,
      id: Number(this.urlDiscountCardId) ?? 0,
      remark: this.remark
    }
    this.sentApiExecuteCityParkingDiscount(body)
  }
  // ( Clear )
  onClearGenerateCode() {
    this.remark = '';
  }

  /* ---- Cityparking Discount Details ----*/
  onSetValueCityparkingDiscountByIdResponse() {
    this.siteId = this.cityparkingDiscountByIdResponse?.siteId ?? 0;
    this.siteName = this.cityparkingDiscountByIdResponse?.siteName ?? '';
    this.name = this.cityparkingDiscountByIdResponse?.name ?? '';
    this.type = this.cityparkingDiscountByIdResponse?.type ?? false;
    this.amount = this.cityparkingDiscountByIdResponse?.amount ?? 0;
    this.startDate = this.cityparkingDiscountByIdResponse?.startDate ?? null;
    this.endDate = this.cityparkingDiscountByIdResponse?.endDate ?? null;
    this.status = this.cityparkingDiscountByIdResponse?.status ?? 1;
    this.codePrefix = this.cityparkingDiscountByIdResponse?.codePrefix ?? '';
    this.qty = this.cityparkingDiscountByIdResponse?.qty ?? 0;
    this.maxUsage = this.cityparkingDiscountByIdResponse?.maxUsage ?? 0;
    this.remark = this.cityparkingDiscountByIdResponse?.remarks ?? '';
  }


  /* --- Table --- */
  // ( Copy )
  onClickCopyCode(code: string) {
    navigator.clipboard.writeText(code).then(() => {
      this.toast.success('คัดลอกเรียบร้อย');
      return;
    });
  }
  // ( Excel )
  onExportToExcel() {
    const headersCityparkingDiscountByIdResponseDetail = [
      'id',
      'name',
      'code',
      'activate',
      'status',
      'createDate',
      'activateDate',
      'maxUsage',
      'usageCount',
    ];

    // รวม headers + sample data
    const worksheet = XLSX.utils.json_to_sheet(
      this.cityparkingDiscountByIdResponse?.details ?? [],
      { header: headersCityparkingDiscountByIdResponseDetail }
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

    XLSX.writeFile(workbook, 'CityparkingDiscount_Template.xlsx');
  }

  /* ---- Cityparking Discount Payload ----*/
  onClickSaveCityparkingDiscount() {
    // ตรวจสอบความถูกต้องข้อมูล
    if (!this.onValidateCityparkingDiscountPayload()) return;
    // ใส่ค่าข้อมูล
    this.onSetValueCityparkingDiscountPayload();
    // ส่ง API
    this.sentApiCityparkingDiscountPayload();
  }
  // ( Validate )
  onValidateCityparkingDiscountPayload() {
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    if (!this.siteId) {
      alert('กรุณาเลือก Site');
      return false;
    } else if (this.siteId <= 0) {
      alert('กรุณาเลือก Site');
      return false;
    } else if (this.name == '') {
      alert('กรุณากรอกชื่อ');
      return false;
    } else if (this.amount <= 0) {
      alert('กรุณากรอกจํานวนราคา / เปอร์เซนต์');
      return false;
    } else if (this.qty <= 0) {
      alert('กรุณากรอกจํานวน');
    } else if (!this.startDate) {
      alert('กรุณาเลือกวันเริ่ม');
      return false;
    } else if (!this.endDate) {
      alert('กรุณาเลือกวันสิ้นสุด');
      return false;
    } else if (this.startDate < today) {
      alert('วันเริ่มต้องไม่ก่อนวันปัจจุบัน');
      return false;
    } else if (this.endDate <= this.startDate) {
      alert('วันสิ้นสุดต้องมากกว่าวันเริ่ม');
      return false;
    } else if (this.codePrefix == '') {
      alert('กรุณากรอกคำนำหน้ารหัส');
      return false;
    } else if (this.codePrefix.length < 3 || this.codePrefix.length > 3) {
      alert('กรุณากรอกคำนำหน้ารหัส 3 ตัวอักษร');
      return false;
    } else if (this.maxUsage <= 0) {
      alert('กรุณากรอกจำนวนสิทธิ์ใช้งาน');
      return false;
    }
    return true
  }
  // ( Set Value )
  onSetValueCityparkingDiscountPayload() {
    this.cityparkingDiscountPayload = {
      siteId: this.siteId ?? 0,
      name: this.name,
      type: this.selectType.value,
      amount: this.amount,
      limit: this.limit,
      startDate: this.startDate,
      endDate: this.endDate,
      userId: Number(this.cookieService.get('user_id')),
      codePrefix: this.codePrefix,
      qty: this.qty,
      maxUsage: this.maxUsage,
      remark: this.remark
    };
  }
  // ( Clear )
  onClearCityparkingDiscountPayload() {
    this.cityparkingDiscountPayload = {
      siteId: 0,
      name: '',
      type: false,
      amount: 0,
      limit: 0,
      startDate: null,
      endDate: null,
      userId: 0,
      codePrefix: '',
      qty: 0,
      maxUsage: 0,
      remark: ''
    }

    this.siteId = 0;
    this.siteName = '';
    this.name = '';
    this.type = false;
    this.amount = 0;
    this.startDate = null;
    this.endDate = null;
    this.limit = 0;
    this.userId = 0,
      this.codePrefix = '',
      this.qty = 0,
      this.maxUsage = 0,
      this.remark = ''
  }
  /* -------------------------------- API -----------------------------------------*/

  /* --- Default --- */
  getProviders() {
    this.apiHandler.handleApi(
      this.apiFormService.getProviders(),
      {
        logLabel: 'getProvider',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: any) => {
          this.allProviders = response;
        },
      }
    );
  }

  /* --- Cityparking Discount Details --- */
  getCityparkingDiscountByIdResponse(id: string) {
    this.apiHandler.handleApi(
      this.apiService.getCityparkingDiscountByIdResponse(id),
      {
        logLabel: 'getCityparkingDiscountByIdResponse',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: CityParkingDiscountByIdResponse) => {
          this.cityparkingDiscountByIdResponse = response;
          this.onSetValueCityparkingDiscountByIdResponse();
        },
      }
    );
  }



  /* --- Cityparking Discount Payload --- */
  sentApiCityparkingDiscountPayload() {
    if (!this.cityparkingDiscountPayload) return;

    this.apiHandler.handleApi(
      this.apiService.sentApiCityparkingDiscountPayload(this.cityparkingDiscountPayload),
      {
        logLabel: 'sentApiCityparkingDiscount',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: () => {
          this.toast.success('สร้างรหัสเรียบร้อย');
          this.onClearCityparkingDiscountPayload();
          if (this.urlDiscountCardId) {
            this.getCityparkingDiscountByIdResponse(this.urlDiscountCardId);
          }
        },
      }
    );
  }

  /* --- Generate Code --- */
  sentApiExecuteCityParkingDiscount(body: ExecuteCityparkingDiscount) {
    this.apiHandler.handleApi(
      this.apiService.sentApiExecuteCityParkingDiscount(body),
      {
        logLabel: 'sentApiExecuteCityParkingDiscount',
        isConsoleLog: true,
        loading: (loading: boolean) => this.isLoading = loading,
        success: (response: ActionApiResponse) => {
          this.toast.success(`สร้างรหัสเรียบร้อย\n${response.message}`);
          this.onClearGenerateCode();
          if (this.urlDiscountCardId) {
            this.getCityparkingDiscountByIdResponse(this.urlDiscountCardId);
          }
        },
        error: () => {
          this.toast.error('สร้างรหัสล้มเหลว');
        },
      }
    );
  }

  get discountEntityId(): number {
    return Number(this.urlDiscountCardId) || 0;
  }

  get canShowActivityHistory(): boolean {
    return this.discountEntityId > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }

}

